var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690726244038,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 18798,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.9 349H107.1c-4.7 0-8.8-3.3-9.8-7.9-1-4.6 1.4-9.3 5.6-11.2l404.9-184c2.6-1.2 5.6-1.2 8.3 0l404.9 184c4.3 1.9 6.6 6.6 5.6 11.2s-5 7.9-9.7 7.9z m-763.6-20h717.4L512 166 153.3 329z",
    fill: "#322E63",
    "p-id": 18799
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M885.6 903.5H137.9c-26.4 0-48-21.6-48-48V342.1c0-26.4 21.6-48 48-48h747.7c26.4 0 48 21.6 48 48v513.4c0 26.4-21.6 48-48 48z",
    fill: "#B9D5EA",
    "p-id": 18800
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M885.6 844.6H137.9c-26.4 0-48-21.6-48-48V342.1c0-26.4 21.6-48 48-48h747.7c26.4 0 48 21.6 48 48v454.5c0 26.4-21.6 48-48 48z",
    fill: "#FFFFFF",
    "p-id": 18801
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M847 844.6H176.5c-13.2 0-24-10.8-24-24V377c0-13.2 10.8-24 24-24H847c13.2 0 24 10.8 24 24v443.6c0 13.2-10.8 24-24 24z",
    fill: "#198EBC",
    "p-id": 18802
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M847 844.6H176.5c-13.2 0-24-10.8-24-24V423.9c0-13.2 10.8-24 24-24H847c13.2 0 24 10.8 24 24v396.7c0 13.2-10.8 24-24 24z",
    fill: "#28B1D5",
    "p-id": 18803
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M885.6 913.5H137.9c-32 0-58-26-58-58V342.1c0-32 26-58 58-58h747.7c32 0 58 26 58 58v513.4c0 32-26 58-58 58zM137.9 304.1c-21 0-38 17-38 38v513.4c0 21 17 38 38 38h747.7c21 0 38-17 38-38V342.1c0-21-17-38-38-38H137.9z",
    fill: "#322E63",
    "p-id": 18804
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M871 649.2c-45.1 4.8-227.6 33.5-382.8 195.4H847c13.2 0 24-10.8 24-24V649.2z",
    fill: "#76C49A",
    "p-id": 18805
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M489 804l-16.2 40.6H847c13.2 0 24-10.8 24-24V804H489z",
    fill: "#4E98A0",
    "p-id": 18806
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M499.8 844.6h231.4c-16.4-25.5-47.8-69.8-95-115.8-63 38.8-110.4 86.4-136.4 115.8z",
    fill: "#4E98A0",
    "p-id": 18807
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M847 854.6H488.2c-4 0-7.6-2.4-9.2-6.1-1.6-3.7-0.8-8 2-10.8 67.1-69.9 146.5-123.4 236.2-159 72.3-28.7 130.9-37.1 152.8-39.4 2.8-0.3 5.6 0.6 7.7 2.5 2.1 1.9 3.3 4.6 3.3 7.4v171.4c0 18.8-15.3 34-34 34z m-334.8-20H847c7.7 0 14-6.3 14-14V660.5c-58.9 7.9-211.4 40.7-348.8 174.1z",
    fill: "#322E63",
    "p-id": 18808
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 536.6v284c0 13.2 10.8 24 24 24h478.3c-162.3-238.6-409.9-295-502.3-308z",
    fill: "#76C49A",
    "p-id": 18809
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M608.8 780.6H152.5v40c0 13.2 10.8 24 24 24h478.4l-46.1-64z",
    fill: "#4E98A0",
    "p-id": 18810
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M419.6 623.9c-103.3-57.7-208.8-79-267.1-86.7v104.1c129.9 3.2 305.5 4 267.1-17.4z",
    fill: "#FFFFFF",
    "p-id": 18811
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M654.8 854.6H176.5c-18.7 0-34-15.3-34-34v-284c0-2.9 1.3-5.6 3.4-7.5 2.2-1.9 5.1-2.8 8-2.4 43.8 6.2 131.5 23.5 227.9 70.3C497.4 653.2 592.1 734.6 663 839c2.1 3.1 2.3 7 0.6 10.3-1.7 3.3-5.1 5.3-8.8 5.3zM162.5 548.2v272.4c0 7.7 6.3 14 14 14h459.1c-152.7-212-372.9-270.5-473.1-286.4z",
    fill: "#322E63",
    "p-id": 18812
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M847 854.6H176.5c-18.7 0-34-15.3-34-34V377c0-18.7 15.3-34 34-34H847c18.7 0 34 15.3 34 34v443.6c0 18.8-15.3 34-34 34zM176.5 363c-7.7 0-14 6.3-14 14v443.6c0 7.7 6.3 14 14 14H847c7.7 0 14-6.3 14-14V377c0-7.7-6.3-14-14-14H176.5z",
    fill: "#322E63",
    "p-id": 18813
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M682 492.9m-93 0a93 93 0 1 0 186 0 93 93 0 1 0-186 0Z",
    fill: "#FFB850",
    "p-id": 18814
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M682 595.9c-56.8 0-103-46.2-103-103s46.2-103 103-103 103 46.2 103 103-46.2 103-103 103z m0-186c-45.8 0-83 37.2-83 83s37.2 83 83 83 83-37.2 83-83-37.2-83-83-83z",
    fill: "#322E63",
    "p-id": 18815
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M511.1 155m-34 0a34 34 0 1 0 68 0 34 34 0 1 0-68 0Z",
    fill: "#FFFFFF",
    "p-id": 18816
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M511.1 199c-24.3 0-44-19.7-44-44s19.7-44 44-44 44 19.7 44 44-19.8 44-44 44z m0-68c-13.2 0-24 10.8-24 24s10.8 24 24 24 24-10.8 24-24-10.8-24-24-24z",
    fill: "#322E63",
    "p-id": 18817
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 363c-2.4 0-4.9-0.9-6.8-2.6l-48-44.4c-4.1-3.7-4.3-10.1-0.6-14.1s10.1-4.3 14.1-0.6l48.1 44.3c4.1 3.7 4.3 10.1 0.6 14.1-2 2.2-4.7 3.3-7.4 3.3zM871 363c-2.7 0-5.4-1.1-7.4-3.2-3.7-4.1-3.5-10.4 0.6-14.1l48.5-44.8c4.1-3.7 10.4-3.5 14.1 0.6 3.7 4.1 3.5 10.4-0.6 14.1l-48.5 44.8c-1.8 1.7-4.3 2.6-6.7 2.6zM919.5 899.4c-2.4 0-4.9-0.9-6.8-2.6L864.2 852c-4.1-3.7-4.3-10.1-0.6-14.1 3.7-4.1 10.1-4.3 14.1-0.6l48.5 44.8c4.1 3.7 4.3 10.1 0.6 14.1-1.9 2.1-4.6 3.2-7.3 3.2zM104 899.4c-2.7 0-5.4-1.1-7.4-3.2-3.7-4.1-3.5-10.4 0.6-14.1l48.5-44.8c4.1-3.7 10.4-3.5 14.1 0.6s3.5 10.4-0.6 14.1l-48.5 44.8c-1.8 1.7-4.3 2.6-6.7 2.6z",
    fill: "#322E63",
    "p-id": 18818
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.bc31c248d548ced773f0d706905fed77.svg";
export { ForwardRef as ReactComponent };